import { useMutation, useQueryClient } from "@tanstack/react-query";
import OnlineOrderPopupValues from "../../../models/formModels/onlineOrderPopupValues.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import moment from "moment";
import toastMessages from "../../helpers/toastMessage";
import CreatePatientPayload from "../../../models/API/requestModels/createPatientPayload.model";

function useEditPatient(oktaAuth?: any) {
  const authState = useOktaAuth()?.authState ?? oktaAuth?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createPatient"],
    mutationFn: (data: OnlineOrderPopupValues) => {
      const payload: CreatePatientPayload = {
        reference: data.reference ?? "",
        firstName: data.firstName,
        lastName: data.lastName,
        middleInitial: data.middleInitial,
        email: data.email,
        gender: data.gender,
        birthDate: moment(data.birthDate).format("MM-DD-YYYY"),
        ssn: data.securityInfo.ssn,
        mrn: data.securityInfo.mrn,
        city: data.city,
        state: data.state,
        phone: data.phone,
        address: data.address,
        zipcode: data.zipcode,
      };

      return axiosInstance
        .patch(`/v1/patients/${data.id}`, payload, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data);
    },
    onError: (error: any) => {
      let errorMessage = error.response.data.message ?? error.message;
      toastMessages.error(errorMessage);
    },
    onSuccess: (res) => {
      toastMessages.success("Patient updated successfully!");
      queryClient.refetchQueries({
        queryKey: ["patientDetail", { id: res?.patientId }],
      });
      queryClient.resetQueries({ queryKey: ["patientsList"] });
    },
  });
}
export default useEditPatient;
